import { axios } from 'lib/axios';
import { useQuery } from 'react-query';

export const getAboutData = () => {
  return axios.get('/about');
};

export const useAboutData = ({ config } = {}) => {
  return useQuery({
    ...config,
    queryKey: ['about_data'],
    queryFn: () => getAboutData(),
  });
};
